var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.kpi)?_c('app-kpiform',{attrs:{"parentObject":{
        kpi: this.kpi,
        pmkpiexercisestatus: this.pmkpiexercisestatus
    }}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }